import { getDateString } from '@/plugins/globals.plugin'

const getDefaultState = () => {
  return {
    data: {
      cpu: 0,
      ram: 0,
      disk: 0,
      firmwareVersion: null,
      syncPoint: null,
      date: null
    },
    cpuReq: null,
    loading: false,
    refreshInterval: 2,
    cpuDataset: [],
    ramDataset: [],
    timeScale: {
      id: '1m',
      resolution: 2,
      timeScale: 1 * 60 * 1000,
      maxDatasetLen: 45,
      name: {
        num: 1,
        unit: 'minute'
      }
    }
  }
}
const state = {
  data: {
    cpu: 0,
    ram: 0,
    disk: 0,
    firmwareVersion: null,
    syncPoint: null,
    date: null
  },
  cpuReq: null,
  loading: false,
  refreshInterval: 2,
  cpuDataset: [],
  ramDataset: [],
  timeScale: {
    id: '1m',
    resolution: 2,
    timeScale: 1 * 60 * 1000,
    maxDatasetLen: 45,
    name: {
      num: 1,
      unit: 'minute'
    }
  }
}

const getters = {
  isStarted: (state) => {
    return state.cpuReq !== null
  },
  getRefreshIntervalOptions: () => {
    return [
      {
        name: '2s',
        value: 2
      },
      {
        name: '10s',
        value: 10
      },
      {
        name: '2m',
        value: 120
      },
      {
        name: '6m',
        value: 360
      },
      {
        name: '12m',
        value: 720
      },
      {
        name: '24m',
        value: 1440
      }
    ]
  },
  getTimeScaleOptions: () => {
    const setMaxDatasetLen = function (timeScaleObj) {
      timeScaleObj.maxDatasetLen = 1.5 * (timeScaleObj.timeScale / (timeScaleObj.resolution * 1000))
    }
    const minute1 = {
      id: '1m',
      resolution: 2,
      timeScale: 1 * 60 * 1000,
      name: {
        num: 1,
        unit: 'minute'
      }
    }
    setMaxDatasetLen(minute1)

    const minute5 = {
      id: '5m',
      resolution: 10,
      timeScale: 5 * 60 * 1000,
      name: {
        num: 5,
        unit: 'minute'
      }
    }
    setMaxDatasetLen(minute5)

    const hour1 = {
      id: '1h',
      resolution: 120,
      timeScale: 60 * 60 * 1000,
      name: {
        num: 1,
        unit: 'hour'
      }
    }
    setMaxDatasetLen(hour1)

    const hour3 = {
      id: '3h',
      resolution: 360,
      timeScale: 3 * 60 * 60 * 1000,
      name: {
        num: 3,
        unit: 'hour'
      }
    }
    setMaxDatasetLen(hour3)

    const hour6 = {
      id: '6h',
      resolution: 720,
      timeScale: 6 * 60 * 60 * 1000,
      name: {
        num: 6,
        unit: 'hour'
      }
    }
    setMaxDatasetLen(hour6)

    const hour24 = {
      id: '24h',
      resolution: 1440,
      timeScale: 24 * 60 * 60 * 1000,
      name: {
        num: 24,
        unit: 'hour'
      }
    }
    setMaxDatasetLen(hour24)

    return [minute1, minute5, hour1, hour3, hour6, hour24]
  }
}

const mutations = {
  CLEAR_DATASETS () {
    state.cpuDataset = []
    state.ramDataset = []
  },
  SET_CPU_DATASET (state, payload = []) {
    state.cpuDataset = payload
  },
  SET_RAM_DATASET (state, payload = []) {
    state.ramDataset = payload
  },
  SET_FRESH_INTERVAL (state, payload) {
    state.refreshInterval = payload
  },
  SET_TIME_SCALE (state, payload) {
    state.timeScale = payload
  },
  SET_DATA (
    state,
    payload = {
      cpu: 0,
      ram: 0,
      disk: 0,
      firmwareVersion: null,
      syncPoint: null,
      date: null
    }
  ) {
    state.data = payload
  },
  SET_CPU_REQ (state, payload = null) {
    state.cpuReq = payload
  },
  SET_LOADING (state, payload = false) {
    state.loading = payload
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  doResetState ({ commit }) {
    commit('resetState')
  },
  async getHsmDateDiff ({ dispatch }) {
    const statInfo = await dispatch('hsm/getStatInfo', {}, { root: true })
    const realDate = Date.now() / 1000
    const hsmDate = statInfo.current_dt_info
    const diff = Math.floor(hsmDate - realDate)
    return diff
  },
  async getInfo ({ commit, dispatch, rootState }) {
    try {
      const body = await rootState.hsm.instance.getStatInfo()
      const obj = {}
      obj.cpu = body.cpu
      obj.ram = body.mem_used
      obj.disk = Math.floor((1 - body.free_blocks / body.total_blocks) * 100)
      obj.firmwareVersion = rootState.hsm.p11Info.firmwareVersion
      obj.syncPoint = body.sync_point
      obj.date = getDateString({ date: body.current_dt_info })

      commit('SET_DATA', obj)
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async updateStats ({ state, commit, dispatch, rootState }) {
    try {
      const body = await rootState.hsm.instance.getStatInfo()

      const obj = {}
      obj.cpu = body.cpu
      obj.ram = body.mem_used
      obj.disk = Math.floor((1 - body.free_blocks / body.total_blocks) * 100)
      obj.firmwareVersion = rootState.hsm.p11Info.firmwareVersion
      obj.syncPoint = body.sync_point
      obj.date = getDateString({ date: body.current_dt_info })

      commit('SET_DATA', obj)

      // CHART
      const newCpuPoint = { x: body.current_dt_info * 1000, y: body.cpu }
      const newRamPoint = { x: body.current_dt_info * 1000, y: body.mem_used }

      const newCpuDataset = state.cpuDataset.concat([newCpuPoint])
      const newRamDataset = state.ramDataset.concat([newRamPoint])

      const cpuLen = newCpuDataset.length
      if (cpuLen > state.timeScale.maxDatasetLen) {
        newCpuDataset.shift()
        newRamDataset.shift()
      }
      commit('SET_RAM_DATASET', newRamDataset)
      commit('SET_CPU_DATASET', newCpuDataset)
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async start ({ state, commit, dispatch }) {
    dispatch('getInfo')
    commit(
      'SET_CPU_REQ',
      setInterval(() => {
        dispatch('updateStats')
      }, state.refreshInterval * 1000)
    )
  },
  async stop ({ state, commit }) {
    if (state.cpuReq) {
      clearInterval(state.cpuReq)
      commit('SET_CPU_REQ')
    }
  }
}

export { state, getters, mutations, actions }
